<template>
  <div id="app" class="layout" v-if="isReady">
    <router-view name="header" />
    <div id="mobile-panel"></div>
    <CabinetContainer>
      <KwAppError>
        <router-view />
      </KwAppError>
    </CabinetContainer>
  </div>
</template>

<script>
import NProgress from 'nprogress';
import responsible from '@/mixins/responsible';
import CabinetContainer from '@/components/CabinetContainer.vue';
import KwAppError from '@/components/KwAppError.vue';
import { isOpenRouter } from './router';

NProgress.configure({ showSpinner: false });

export default {
  name: 'app',
  mixins: [responsible()],
  components: {
    CabinetContainer,
    KwAppError,
  },
  data() {
    return {
      isUserLoaded: false,
    };
  },
  computed: {
    isReady() {
      return this.$store.getters.appIsReady && this.isUserLoaded;
    },
  },
  methods: {
    onResize() {
      this.$store.dispatch('changeViewSize', window.innerWidth);
    },
    fetchUser() {
      if (isOpenRouter(this.$router.history.pending.name)) {
        return Promise.resolve();
      }
      return this.$store.dispatch('$_user/fetchCurrentUser');
    },
  },
  created() {
    this.onResize();
  },
  mounted() {
    NProgress.start();
    Promise.all([
      this.$store.dispatch('GET_TRANSLATIONS'),
      this.fetchUser(),
    ])
      .then(() => {
        NProgress.done();
        this.isUserLoaded = true;
      })
      .catch(NProgress.done);
  },
};
</script>

<style lang="scss">
@import './assets/stylesheet/reset';
@import '/assets/stylesheet/atomic/atomic';
@import '/assets/stylesheet/tippy/tippy';
@import 'assets/stylesheet/np-progress/_np-progress.scss';
@import '/assets/stylesheet/grid/bootstrap-grid';
@import '../node_modules/flatpickr/dist/flatpickr.css';
@import './assets/stylesheet/typography';
@import './assets/stylesheet/animations';
@import './assets/stylesheet/ui';
@import './assets/stylesheet/flatpickr-custom';

@import '~@kiwitaxi/vue-components/dist/styles/index.css';
@import '~@kiwitaxi/vue-components/dist/styles/ClientMenu.css';

* {
  box-sizing: border-box;
}

html, body {
  width: 100%;
  height: 100%;
  font-size: 16px;
}

body {
  font-size: 100%;
  line-height: 1.2;
  @include base-font;
  color: $base;
  background: $base-subtle;
  text-rendering: optimizeLegibility;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  font-smoothing: antialiased;
  -webkit-text-size-adjust: none;
  text-size-adjust: none;
}

 #mobile-panel {
   height: 100%;
 }

.layout {
  height: auto;
  min-height: 100%;
  display: flex;
  flex-direction: column;
}

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to  {
    opacity: 0;
  }

.hidden {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue